import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FileUploadState } from 'app/main/file-upload/file-upload.reducer';
import * as fromFileUpload from 'app/main/file-upload/file-upload.reducer';
import { FileUploadQuery } from 'app/main/file-upload/file-upload.actions';
import { LoadingState, getError } from 'app/utils/callstate';
import * as _ from 'lodash';

export const selectFileUploadState = createFeatureSelector<FileUploadState>('fileUpload');

export const selectFileUpload = createSelector(
  selectFileUploadState,
  fromFileUpload.selectAll
);

export const selectFileUploadByCompany = (companyId: string) => createSelector(
  selectFileUpload,
  entries => _.filter(entries, entry => entry.companyId === companyId)
);

export const selectFileUploadLoading = (companyId: string) => createSelector(
  selectFileUploadState,
  fileUploadState => fileUploadState.calls[companyId].callState === LoadingState.Loading
);

export const selectFileUploadLoaded = (companyId: string) => createSelector(
  selectFileUploadState,
  fileUploadState => fileUploadState.calls[companyId].callState === LoadingState.Loading
);

export const selectFileUploadError = (companyId: string) => createSelector(
  selectFileUploadState,
  fileUploadState => getError(fileUploadState.calls[companyId].callState)
);

export const selectFileUploadQuery = (companyId: string) => createSelector(
  selectFileUploadState,
  fileUploadState => ({
    companyId: fileUploadState.calls[companyId].companyId,
    key: fileUploadState.calls[companyId].key,
    filter: fileUploadState.calls[companyId].filter
  } as FileUploadQuery)
);

